import { ASComponentSize, ComponentSize } from '@eleventheye/asui';
import React, { PropsWithChildren } from 'react';

import styles from './ButtonGroup.module.scss';

export type ButtonGroupProps = {
  className?: string;
  itemSize?: ASComponentSize;
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'style' | 'onClick'>;

const ButtonGroup: React.FC<PropsWithChildren<ButtonGroupProps>> = ({
  className = '',
  children,
  itemSize = ComponentSize.Medium,
  ...props
}) => {
  const baseCls = `${styles.ButtonGroup} ${styles[itemSize]} ${className}`;

  return (
    <div className={baseCls} onClick={props.onClick}>
      {children}
    </div>
  );
};

type ItemProps = {
  className?: string;
  selected?: boolean;
  disabled?: boolean;
  useUpperCase?: boolean;
  size?: ASComponentSize;
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'style' | 'onClick' | 'aria-disabled'>;
const ButtonGroupItem: React.FC<PropsWithChildren<ItemProps>> = ({ className = '', selected, children, ...props }) => {
  const sizeCls = `${styles[props.size ?? ComponentSize.Large]}`;
  const upperCaseCls = props.useUpperCase ? styles.UpperCase : '';
  const baseCls = `${styles.ButtonGroupItem} ${upperCaseCls} ${className} ${sizeCls} ${selected ? styles.Selected : ''}`;

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (props.disabled || !props.onClick) {
      e.preventDefault();
      return;
    }
    props.onClick(e);
  };
  return (
    <div className={baseCls} aria-disabled={!!props.disabled} onClick={onClick}>
      {children}
    </div>
  );
};

export { ButtonGroupItem, ButtonGroup as default };
